<template>
  <div class="bg-white rounded-lg p-4">
    <h2
      class="text-lg font-semibold mb-4 border-b border-gray-475 pb-2 text-university-primary"
      data-testid="recent-activity-title"
    >
      Recent Activity
    </h2>
    <ul class="space-y-2">
      <li
        v-for="(date, key) in activityData"
        :key="key"
        class="text-university-primary"
        :data-testid="`activity-${key}`"
      >
        <span class="font-semibold">{{ formatLabel(key) }}</span>
        <span class="block mt-1">{{ date }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  activityData: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});

const formatLabel = (key) => {
  return key
    .replace(/([A-Z])/g, " $1")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
</script>
